export const formatAmount = (amount: number) => {
  return amount % 1 !== 0 ? amount.toFixed(1) : amount.toFixed(0);
};

export const shortenAddress = (address: string, length = 10) =>
  address.slice(0, length) + "..." + address.slice(-length);
